import Vue from 'vue'
import Vuex from 'vuex'

import analyte from './analyte'
import approvalLevels from './approvalLevels'
import guidelines from './guidelines'
import guidelinesparameter from './guidelinesparameter'
import imports from './imports'
import app from './app'
import sampleactivity from './sampleactivity'
import stationmetadata from './stationmetadata'
import stations from './stations'
import authenticate from './authenticate'
import admin from './admin'
import rawdatarepository from './rawdatarepository'
import datasetfilter from './datasetfilter'
import datum from './datum'
import flags from './flags'
import reviewingestionresults from './Services/reviewingestionresults'
import datastate from './datastate'
import multistation from './Services/multistation'
import services from './ServiceRegistry/services'
import servicerefreshtokens from './ServiceRegistry/servicerefreshtokens'
import monitoringfeature from './MonitoringFeature/monitoringfeature'
import datasource from './MonitoringFeature/datasource'
import serviceconfigurations from './ServiceRegistry/serviceconfigurations'
import servicecredentials from './ServiceRegistry/servicecredentials'
import servicelogs from './ServiceRegistry/servicelogs'
import vegetativemonitoring from './vegetativemonitoring'
import tutorial from './UI/tutorial'
import uiconfig from './UI/uiconfig'
import navigation from './UI/navigation'
import linkedservices from './ServiceRegistry/linkedservices'
import importnotification from './Services/importnotification'
import synonyms from './MonitoringFeature/DataSources/synonyms'
import stationmanagement from './MonitoringFeature/DataSources/DiscreteEnviroData/stationmanagement'
import adminaquariusstation from './Administration/adminaquariusstation'
import plugin from './ServiceRegistry/plugin'
import ingestions from './ingestions'
import landingPageStaticContent from './landingPageStaticContent'
import started from './started'
import grades from './grades'
import qualifiers from './qualifiers'
import logging from './logging'
import continuousdbconfig from './continuousdbconfig'
import continuousimporterconfig from './continuousimporterconfig'
import cofactor from './cofactor'
import unit from './unit'
import map from './map'
import tenants from './tenants'
import messages from './messages'
import ingestionManagement from './ingestionManagement'
import dashboard from './dashboard'

Vue.use(Vuex)

export default new Vuex.Store({
  actions: {
    exitApplication({
      commit,
    }) {
      var allStores = Object.values(this._modules.root._children)
      var allStoresName = Object.keys(this._modules.root._children)

      // app.js snackbar won't be reset in order to show authentication messages.
      allStores.forEach((x, index) => {
        if (x._rawModule.mutations.RESET) {
          commit(`${allStoresName[index]}/RESET`)
        }
      })

      // FUTURE WORK: Consider adding exception keys as a default to each store.
      // Not implemented for now because only the app.js store has special rules.
      // https://git.hatfieldgroup.net/hatfield/wrd/-/merge_requests/1055#note_12312

      // let resetExceptions = {
      //   'app': ['snackbar']
      // }

    },
  },
  modules: {
    admin,
    tenants,
    authenticate,
    analyte,
    guidelines,
    guidelinesparameter,
    imports,
    app,
    sampleactivity,
    stationmetadata,
    stations,
    rawdatarepository,
    datasetfilter,
    datum,
    flags,
    reviewingestionresults,
    unit,
    datastate,
    map,

    // Services
    multistation,
    importnotification,

    // Service Registry
    services,
    linkedservices,
    serviceconfigurations,
    servicecredentials,
    servicelogs,
    vegetativemonitoring,
    plugin,
    landingPageStaticContent,
    servicerefreshtokens,
    //started,

    // Administration
    adminaquariusstation,

    // Monitoring Features
    monitoringfeature,
    datasource,

    // Data Sources
    synonyms,
    // DiscreteEnvirodata
    stationmanagement,

    // UI
    uiconfig,
    tutorial,
    navigation,
    ingestions,
    started,
    approvalLevels,
    grades,
    qualifiers,
    logging,
    continuousdbconfig,
    continuousimporterconfig,
    cofactor,
    messages,
    ingestionManagement,
    dashboard,
  },
})